// src/pages/TestCard.jsx
import { useEffect, useMemo, useRef } from "react";

// Normalize course id for filesystem folder names
function fsSlug(raw) {
  const s = String(raw || "").toLowerCase();
  if (
    s === "focus-family" ||
    s === "focus_on_the_family" ||
    s === "focus-on-the-family" ||
    s === "focus"
  ) {
    return "family";
  }
  if (s === "danielrevelation" || s === "daniel_revelation") {
    return "daniel-revelation";
  }
  return s;
}

// Base path for static assets (respects CRA PUBLIC_URL / subfolder deploys)
const PUBLIC_BASE = process.env.PUBLIC_URL || "";

const TestCard = ({ courseId, lessonId, onTestSubmit }) => {
  const iframeRef = useRef(null);

  // Match the filesystem slug used under /public/tests/*
  const fsCourseId = useMemo(() => fsSlug(courseId), [courseId]);

  // ✅ IMPORTANT: use PUBLIC_BASE so it works under /test/vop or any subpath
  const testUrl = `${PUBLIC_BASE}/tests/${fsCourseId}/lesson${lessonId}-test.html`;

  useEffect(() => {
    function handleMessage(e) {
      const data = e.data;

      if (!data || !data.type) return;

      // 1) Main format: { type: "TEST_SUBMIT", answers, result, meta }
      if (data.type === "TEST_SUBMIT") {
        const answers = data.answers || {};

        // Support both formats: new (data.result) and old (flat fields)
        const result = data.result
          ? data.result
          : {
              percent: data.percent,
              correct: data.correct,
              total: data.total,
              passed: data.passed,
              passMark: data.passMark,
              graded: data.graded,
            };

        onTestSubmit?.(answers, result);
        return;
      }

      // 2) Backwards-compat example: { type: "VOP_TEST_RESULT", payload: {...} }
      if (data.type === "VOP_TEST_RESULT") {
        const payload = data.payload || {};
        const answers = payload.answers || {};

        const {
          correct = payload.correct,
          total = payload.total,
          percent = payload.percent,
          passed = payload.passed,
          passMark = payload.passMark,
          graded = payload.graded,
        } = payload.result || payload;

        const result = { correct, total, percent, passed, passMark, graded };
        onTestSubmit?.(answers, result);
      }
    }

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, [onTestSubmit]);

  return (
    <iframe
      ref={iframeRef}
      src={testUrl}
      title={`Lesson ${lessonId} Test`}
      className="w-full min-h-[70vh] rounded-2xl border border-orange-200 bg-white"
    />
  );
};

export default TestCard;
